import { render } from "./page-footer.html?vue&type=template&id=2f2744fa&scoped=true&ts=true&external"
import script from "./page-footer.ts?vue&type=script&lang=ts&external"
export * from "./page-footer.ts?vue&type=script&lang=ts&external"

import "./page-footer.scss?vue&type=style&index=0&id=2f2744fa&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2744fa"]])

export default __exports__